export default __webpack_public_path__ + "static/media/accented_stone.75defb1e.webp";